import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Col, Collapse, Row,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import Section from '../../components/Section';
import Tabs from '../../components/Tabs';
import SelectedPlants from './Selection/SelectedPlants';
import FloweringArch from '../../components/FloweringArch';
import {
  getAdvice,
  getFloweringArch,
  selectWithAdviceFloweringArch,
} from '../../ducks/floweringArch';
import { floweringArchTypesEnum } from '../../ducks/floweringArch/types';

import SelectPlants from './Selection/SelectPlants';
import { componentsEnum } from '../../utils/types';
import HorizontalBeeShowcase from '../../components/HorizontalBeeShowcase';
import { selectSelectedPlantsDuringAdvice } from '../../ducks/plants';

const Bold = styled.span`
  font-weight: 600;
  display: block;
`;

const BloeiboogButton = styled.button`
  background: none;
  color: black;
  font-weight: 600;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  font-size: 0.9rem;
  opacity: 0.7;
`;

const PlantAdvice = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const selectedPlantIds = useSelector(selectSelectedPlantsDuringAdvice);

  const withAdviceFloweringArch = useSelector(selectWithAdviceFloweringArch);
  const coverage = withAdviceFloweringArch.coverage.overall;

  useEffect(() => {
    dispatch(getFloweringArch(floweringArchTypesEnum.basedOnAdvise));
    dispatch(getAdvice());
  }, []);

  return (
    <Section
      noCentering
      previousNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.floweringArch].route,
        ),
      }}
      nextNav={{
        disabled: false,
        handleClick: () => history.push(
          componentsEnum.properties[componentsEnum.overview].route,
        ),
      }}
      nextNavSticky
      {...props}
    >
      <Row className="justify-content-md-center">
        <Col className="text-center" md={10}>
          <h2>Plantadvies</h2>
          <p>
            Je vindt hier een overzicht van de planten die geschikt zijn voor jouw geselecteerde
            bijen. Selecteer de plantensoorten die je wilt aanplanten om de bloeiboog compleet te
            maken. Houd er rekening mee dat er voor elke bijensoort gedurende de hele vliegtijd minstens 5
            verschillende plantensoorten aanwezig moeten zijn voor een optimale voedseldekking
            voor de bijen.
          </p>
          <p>
            De voortgang in je bloeiboog kun je zien door de bloeiboog hieronder uit te klappen.
          </p>
        </Col>
      </Row>
      <Row className="mt-5 mb-5 pt-3 pb-3">
        <Col>
          <Bold>
            Gemiddelde voedseldekking:
            {' '}
            {coverage}
            %
          </Bold>
          <HorizontalBeeShowcase className="pt-2 pb-3 mb-2 " archInfo={withAdviceFloweringArch} />
          <BloeiboogButton
            as="button"
            onClick={() => {
              setOpen(!open);
            }}
            aria-expanded={open}
            className="mt-2"
          >
            { open ? (
              <span>
                <FontAwesomeIcon className="mr-1" icon="chevron-down" />
                Verstop bloeiboog
              </span>
            ) : (
              <span>
                <FontAwesomeIcon className="mr-1" icon="chevron-right" />
                Bekijk bloeiboog
              </span>
            )}
          </BloeiboogButton>
          <Collapse className="pt-3" in={open}>
            <Row>
              <Col>
                <FloweringArch archInfo={withAdviceFloweringArch} />
              </Col>
            </Row>
          </Collapse>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs
            tabs={[
              {
                name: 'Beplanting  toevoegen',
                pane: (<SelectPlants />),
                key: 'add',
              },
              {
                name: `Geselecteerde beplanting (${selectedPlantIds.length})`,
                pane: (<SelectedPlants />),
                key: 'remove',
              },
            ]}
          />
        </Col>
      </Row>
    </Section>
  );
};

export default PlantAdvice;
